import React, { forwardRef } from "react";
import styled, { css, keyframes } from "styled-components";
const sizeMap = {
  xs: ".938em",
  sm: "1.094em",
  lg: "1.438em",
  xl: "1.725em",
  "2x": "2.30em",
  "3x": "3.45em",
  "4x": "4.60em",
  "5x": "5.75em",
  "huge": "10.35em"
};
const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
`;
const StyledSpan = styled.span(
  ({ $bsStyle, $size, $spin, $rotation, $flip, $fill, theme }) => {
    var _a;
    return css`
    font-variation-settings:
      'opsz' 48,
      'wght' 700 ${$fill ? ", 'FILL' 1" : ""};
    font-size: ${(_a = sizeMap[$size]) != null ? _a : "1.15em"};
    transform: rotate(${$rotation}deg) scaleY(${$flip === "horizontal" || $flip === "both" ? -1 : 1})
      scaleX(${$flip === "vertical" || $flip === "both" ? -1 : 1});
    animation: ${$spin ? css`
          ${spinAnimation} 2s infinite linear
        ` : "none"};
    vertical-align: middle;
    color: ${$bsStyle ? theme.colors.button[$bsStyle].background : "inherit"};
  `;
  }
);
const Icon = ({
  bsStyle = void 0,
  name,
  type = "solid",
  size = void 0,
  className = void 0,
  rotation = 0,
  spin = false,
  flip = void 0,
  style = void 0,
  "data-testid": testId = void 0,
  onClick = void 0,
  onMouseEnter = void 0,
  onMouseLeave = void 0,
  onFocus = void 0,
  tabIndex = void 0,
  title = void 0
}, ref) => /* @__PURE__ */ React.createElement(
  StyledSpan,
  {
    "aria-hidden": true,
    className: `material-symbols-rounded ${className != null ? className : ""}`,
    "data-testid": testId,
    onClick,
    style,
    title,
    onFocus,
    onMouseEnter,
    onMouseLeave,
    tabIndex,
    ref,
    $bsStyle: bsStyle,
    $rotation: rotation,
    $flip: flip,
    $size: size,
    $fill: type === "solid",
    $spin: spin
  },
  name
);
export default forwardRef(Icon);
